import type { MenuExtendedProps } from "config/menus/menus.d";
import { useTranslations } from "contexts/LocalizationContext";
import MenuLink from "modules/common/components/MenuLink";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

export const TopMenuLink = ({ menuItem }: { menuItem: MenuExtendedProps }) => {
  const { subMenu, label } = menuItem;
  const translations = useTranslations();
  const pathname = usePathname();
  const url = menuItem?.href && new URL(menuItem.href);
  let isActive = url?.pathname === pathname;

  const submenuActiveItem = useMemo(
    () =>
      subMenu?.findIndex((item) => {
        const subUrl = item?.href && new URL(item.href);
        return subUrl?.pathname === pathname;
      }),
    [subMenu, pathname]
  );

  if (subMenu && subMenu[submenuActiveItem]) {
    isActive = true;
    subMenu[submenuActiveItem].active = true;
  }

  return (
    <MenuLink
      fontWeight={isActive ? "medium" : "inherit"}
      color="primary.900"
      rounded="none"
      variant="footerDark"
      fontSize={{ base: "lg", lg: "md" }}
      menuItem={menuItem}
      textDecoration={isActive && !subMenu ? "underline" : "none"}
      textUnderlineOffset="2px"
      linkType={subMenu ? "span" : "a"}
      pl={{ base: 0, lg: 2 }}
      pr={{ base: 2, lg: 2 }}
      textAlign={{ base: "left", lg: "center" }}
      position="relative"
      _after={{
        left: 0,
        content: `"${translations(label)}"`,
        fontWeight: "normal",
        position: "absolute",
        opacity: 0,
        width: "full",
      }}
      _hover={{ color: "transparent", _after: { fontWeight: "medium", color: "primary.500", opacity: 1 } }}
      transition="opacity 0.2s linear"
      sx={{ textDecorationSkipInk: "none" }}
    />
  );
};
